import { useState } from 'react';
import { usePrivacyConsentStore } from './usePrivacyConsentStore';
export const useConsentModalState = (grouped) => {
    const setConsents = usePrivacyConsentStore((state) => state.setConsents);
    const closeConsents = usePrivacyConsentStore((state) => state.closeConsents);
    const storedConsents = usePrivacyConsentStore.getState().consents;
    const [categoryState, setCategoryState] = useState(() => {
        const state = {};
        for (const { category, services: cServices } of grouped) {
            state[category] = category === 'necessary' || cServices.every((service) => storedConsents[service.id] === true);
        }
        return state;
    });
    const toggleCategory = (category) => {
        if (category === 'necessary')
            return;
        setCategoryState((prev) => ({ ...prev, [category]: !prev[category] }));
    };
    const commit = (resolver) => {
        const map = {};
        for (const service of grouped.flatMap((group) => group.services)) {
            map[service.id] = service.category === 'necessary' ? true : resolver(service.category);
        }
        setConsents(map);
        closeConsents();
    };
    const handleAcceptAll = () => commit(() => true);
    const handleDenyAll = () => commit(() => false);
    const handleSave = () => commit((category) => categoryState[category] ?? false);
    return { categoryState, toggleCategory, handleAcceptAll, handleDenyAll, handleSave };
};
